import { gql } from '@apollo/client';
import { getCartQueryString } from './utils';

export const getVignetteProductDoneCollection = gql`
	query getVignetteProductDoneCollection($lang: String) {
		vignetteProductDoneCollection(locale: $lang, limit: 1) {
			items {
				headline(locale: $lang)
				text(locale: $lang)
        upsellHeading(locale: $lang)
        upsellText(locale: $lang)
        upsellStartDate(locale: $lang)
        helpDrawers: helpDrawersCollection(locale: $lang, limit: 7) {
          items {
            id
            helpDrawerTitle(locale: $lang)
          }
        }
        hintMessages: hintMessagesCollection(locale: $lang, limit: 6) {
          items {
            id
            tip(locale: $lang)
            message(locale: $lang) {
              json
            }
            linkText(locale: $lang)
          }
        }
				addProductLabel(locale: $lang)
                productAddedToast(locale: $lang)
                productAddedToastLink(locale: $lang)
                ${getCartQueryString()}
            }
        }
	}
`;
